import { render, staticRenderFns } from "./BaseSidebarMenu.vue?vue&type=template&id=5042e88d&"
import script from "./BaseSidebarMenu.vue?vue&type=script&lang=js&"
export * from "./BaseSidebarMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports